<div
  class="inactivity-overlay"
  [class.inactivity-overlay--visible]="inactivityState.isWarningVisible"
  [attr.role]="inactivityState.isWarningVisible ? 'alert' : null"
  [attr.aria-live]="inactivityState.isWarningVisible ? 'assertive' : null"
  [attr.aria-atomic]="inactivityState.isWarningVisible ? 'true' : null"
  [attr.aria-hidden]="!inactivityState.isWarningVisible">
  <div class="backdrop"></div>
  <div class="inactivity-toast">
    <div class="toast-card" [class.toast-card--pulse]="inactivityState.isWarningVisible">
      <div class="toast-content">
        <div class="icon-timer-group">
          <div class="warning-icon">
            <i class="ri-timer-line"></i>
          </div>
          <div class="timer-display">
            <span class="countdown-time" [class]="getTimerClass()">{{ getFormattedTime() }}</span>
          </div>
        </div>
        <div class="message-group">
          <h6 class="toast-title">{{ 'INACTIVITY.SESSION_EXPIRING' | translate }}</h6>
          <p class="toast-message">{{ 'INACTIVITY.ACTIVITY_MESSAGE' | translate }}</p>
        </div>
      </div>
      <div class="progress-container">
        <div
          class="progress-bar"
          [style.width.%]="getProgressWidth()"
          [class]="getTimerClass()">
        </div>
      </div>
    </div>
  </div>
</div>
